import React from "react";

import { QRProps } from "@/contexts/QREditorContext/types";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { Lazy } from "@/components/Lazy";
import { Video } from "@/components/Video";

import { useYoutubeData } from "./hooks";

import "./YoutubeTemplate.scss";

export const YoutubeTemplate = (props: QRProps<"youtube">) => {
  const {
    isInitPreview,
    logoUrl,
    youtubeEmbedLink,
    backgroundColor,
    handleVideoReady,
    handleVideoError,
  } = useYoutubeData(props);

  return (
    <PhoneLayout
      page="youtube"
      dataQA="preview-youtube-container"
      backgroundColor={backgroundColor}
      isInitPreview={isInitPreview}
      hasIncludeBrowser
    >
      <div className="youtube-template">
        <div className="youtube-template__video-wrapper">
          {isInitPreview ? (
            <Lazy placeholderClass="youtube-template__skeleton">
              <img
                src={logoUrl}
                alt="youtube video preview"
              />
            </Lazy>
          ) : (
            <Video
              url={youtubeEmbedLink}
              onReady={handleVideoReady}
              onError={handleVideoError}
            />
          )}
        </div>
      </div>
    </PhoneLayout>
  );
};
